export default __webpack_public_path__ + "static/media/you.62c19a64.svg";